<template>
  <div
    ref="kt_modal_leitura_barras"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_leitura_barras"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/ecommerce/ecm010.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Barras</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <div class="scanner-container">
              <div v-show="!isLoading">
                <video poster="data:image/gif,AAAA" ref="scanner"></video>
                <div class="overlay-element"></div>
                <div class="laser"></div>
              </div>
              <div
                v-if="isLoading"
                class="d-flex justify-content-center align-items-center overlay-layer card-rounded bg-dark bg-opacity-5 h-100px"
              >
                <div class="spinner-border text-primary" role="status"></div>
                <span class="ms-2">Aguarde, carregando...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModalId } from "@/core/helpers/dom";
import { BrowserMultiFormatReader, Exception } from "@zxing/library";

export default {
  emits: ["exibirModalLeituraBarras", "confirmarModalLeituraBarras"],
  components: {},
  methods: {
    onDecode(result) {
      hideModalId("kt_modal_leitura_barras", () => {
        this.beep();
        this.codeReader.reset();
        this.$emit("confirmarModalLeituraBarras", result);
        this.$emit("exibirModalLeituraBarras", false);
      });
    },

    beep() {
      const context = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = context.createOscillator();
      const gainNode = context.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(context.destination);
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(440, context.currentTime);
      oscillator.start();

      gainNode.gain.exponentialRampToValueAtTime(
        0.00001,
        context.currentTime + 1
      );
      oscillator.stop(context.currentTime + 1);
    },

    cancelar() {
      hideModalId("kt_modal_leitura_barras", () => {
        this.codeReader.reset();
        this.$emit("exibirModalLeituraBarras", false);
      });
    },

    start() {
      this.codeReader.decodeFromVideoDevice(
        undefined,
        this.$refs.scanner,
        (result, err) => {
          if (result) {
            if (this.leituraRealizada === false) {
              this.leituraRealizada = true;
              this.onDecode(result.text);
            }
          }
        }
      );
    },
  },
  mounted() {
    if (!this.isMediaStreamAPISupported) {
      throw new Exception("Media Stream API is not supported");
    }

    this.start();
    this.$refs.scanner.oncanplay = (event) => {
      this.isLoading = false;
    };
  },
  data() {
    return {
      leituraRealizada: false,
      isLoading: true,
      codeReader: new BrowserMultiFormatReader(),
      isMediaStreamAPISupported:
        navigator &&
        navigator.mediaDevices &&
        "enumerateDevices" in navigator.mediaDevices,
    };
  },
};
</script>

<style scoped>
video {
  max-width: 100%;
  max-height: 100%;
}
.scanner-container {
  position: relative;
}

.overlay-element {
  position: absolute;
  top: 0;
  width: 100%;
  height: 99%;
  background: rgba(30, 30, 30, 0.5);

  -webkit-clip-path: polygon(
    0% 0%,
    0% 100%,
    20% 100%,
    20% 20%,
    80% 20%,
    80% 80%,
    20% 80%,
    20% 100%,
    100% 100%,
    100% 0%
  );
  clip-path: polygon(
    0% 0%,
    0% 100%,
    20% 100%,
    20% 20%,
    80% 20%,
    80% 80%,
    20% 80%,
    20% 100%,
    100% 100%,
    100% 0%
  );
}

.laser {
  width: 60%;
  margin-left: 20%;
  background-color: tomato;
  height: 1px;
  position: absolute;
  top: 40%;
  z-index: 2;
  box-shadow: 0 0 4px red;
  -webkit-animation: scanning 2s infinite;
  animation: scanning 2s infinite;
}
@-webkit-keyframes scanning {
  50% {
    -webkit-transform: translateY(75px);
    transform: translateY(75px);
  }
}
@keyframes scanning {
  50% {
    -webkit-transform: translateY(75px);
    transform: translateY(75px);
  }
}
</style>
